import ScrollReveal from "./ScrollReveal";
import { ArrowRight, Clock } from "lucide-react";

const HERO_IMAGE = "/images/avatar.png";

export default function HeroSection() {
  const scrollToContact = (e) => {
    e.preventDefault();
    document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section data-testid="hero-section" className="relative pt-24 lg:pt-[156px] pb-16 lg:pb-24 overflow-hidden bg-[#0284FC]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <ScrollReveal>
            <div className="space-y-8">
              <div className="inline-flex items-center gap-2 bg-white/15 text-white px-4 py-1.5 rounded-full text-sm font-semibold backdrop-blur-sm">
                Covering professionnel
              </div>
              <h1
                data-testid="hero-title"
                className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter text-white leading-[1.05]"
              >
                Offrez une nouvelle vie à votre cuisine{" "}
                <span className="text-white/70">sans tout casser</span>{" "}
                <span className="text-white/50 font-bold text-3xl sm:text-4xl lg:text-5xl">(ni dépenser 10 000&euro;)</span>
              </h1>
              <p className="text-base sm:text-lg text-white/80 leading-relaxed max-w-xl">
                Résultat haut de gamme en 2 jours, sans poussière ni chantier lourd.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a
                  href="#contact"
                  data-testid="hero-cta"
                  onClick={scrollToContact}
                  className="inline-flex items-center justify-center gap-2 bg-white hover:bg-white/90 text-[#0284FC] font-bold px-8 py-4 rounded-full transition-all hover:scale-105 text-base"
                >
                  Obtenir mon devis gratuit en 24h
                  <ArrowRight className="w-5 h-5" />
                </a>
                <a
                  href="#avant-apres"
                  data-testid="hero-secondary-cta"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector("#avant-apres")?.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="inline-flex items-center justify-center gap-2 border-2 border-white/30 hover:border-white/50 text-white font-semibold px-8 py-4 rounded-full transition-all hover:bg-white/10 text-base"
                >
                  Voir les réalisations
                </a>
              </div>
              <p className="flex items-center gap-2 text-sm text-white/60 font-medium">
                <Clock className="w-4 h-4 text-white/60" />
                Planning limité — intervention sur rendez-vous uniquement
              </p>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={0.2}>
            <div className="relative">
              <img
                src={HERO_IMAGE}
                alt="Cuisine moderne rénovée par Vinylux"
                data-testid="hero-image"
                className="w-full rounded-3xl shadow-2xl shadow-black/20 object-cover aspect-[4/3]"
              />
              <div className="absolute -bottom-4 -left-4 sm:bottom-6 sm:-left-6 bg-white rounded-2xl shadow-lg p-4 sm:p-5">
                <div className="text-[#0284FC] font-heading font-black text-2xl sm:text-3xl">48h</div>
                <div className="text-[#0284FC]/60 text-xs sm:text-sm font-semibold">Délai moyen</div>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}
